var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color-sku-item"},[_c('a-space',[_c('span',[_vm._v(" "+_vm._s(_vm.item.value)+" ")])]),_c('span',{staticClass:"operate-button",on:{"click":_vm.remove}},[_vm._v(" 删除 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }